import { CongestionSettingSchema } from "./congestion";
import { z } from "zod";
import { QueryQcBizFacilityOptionsSchema } from "./facilityAdmin";
import { LocationsSchema } from "@/modules/staff/objects/guest/Locations";

export type FacilityImage = z.infer<typeof FacilityImageSchema>;
export const FacilityImageSchema = z.object({
  id: z.number(),
  facility_id: z.number(),
  url: z.string(),
  order_no: z.number(),
});

export type FacilityBizHour = z.infer<typeof FacilityBizHourSchema>;
export const FacilityBizHourSchema = z.object({
  id: z.number(),
  facility_id: z.number(),
  title_dict: z.string().optional(),
  title: z
    .string()
    .nullable()
    .optional()
    .transform((value) => value ?? ""),
  description_dict: z.string().optional(),
  description: z
    .string()
    .nullable()
    .optional()
    .transform((value) => value ?? ""),
});

export type Facility = z.infer<typeof FacilitySchema>;
export const FacilitySchema = z.object({
  id: z.number(),
  tenant_id: z.number(),
  sub_menu_id: z.number(),
  name_dict: z.string(),
  name: z.string(),
  genre_dict: z.string(),
  genre: z.string(),
  location_dict: z.string(),
  location: z.string(),
  description_dict: z.string(),
  description: z.string(),
  description2_dict: z.string(),
  description2: z.string(),
  images: z.array(FacilityImageSchema),
  business_hours: z.array(FacilityBizHourSchema),
  order_no: z.number(),
  congestion_setting: CongestionSettingSchema,
  has_popupmenu: z.boolean(),
  is_display: z.boolean(),
  facility_options: z.array(QueryQcBizFacilityOptionsSchema),
});

export type SubMenuLocations = z.infer<typeof SubMenuLocationsSchema>;
export const SubMenuLocationsSchema = z.object({
  id: z.number().optional(),
  location_main_menu_id: z.number().optional(),
  order_no: z.number().optional(),
  sub_menu_id: z.number().optional(),
});

export type MainMenuLocations = z.infer<typeof MainMenuLocationsSchema>;
export const MainMenuLocationsSchema = z.object({
  id: z.number().optional(),
  location_group_id: z.number().optional(),
  main_menu_id: z.number().optional(),
  order_no: z.number().optional(),
  sub_menus: z.array(SubMenuLocationsSchema).optional(),
});

export type LocationGroups = z.infer<typeof LocationGroupsSchema>;
export const LocationGroupsSchema = z.object({
  color: z.string().optional(),
  display_name: z.string().optional(),
  id: z.number().optional(),
  is_default: z.boolean().optional(),
  is_show_chat_history: z.boolean().optional(),
  locations: z.array(LocationsSchema).optional(),
  main_menus: z.array(MainMenuLocationsSchema).optional(),
  name: z.string().optional(),
  position: z.number().optional(),
  tenant_id: z.number().optional(),
});
